<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="告警列表">
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="编码">
              <a-input  v-model="searchP.keyword"  placeholder="appcode或系统编码" ></a-input>
          </a-form-item>
          <a-form-item label="服务地址">
              <a-input  v-model="searchP.serviceurl"  placeholder="请输入服务地址" ></a-input>
          </a-form-item>
          <a-form-item label="告警类型">
                <a-select v-model="searchP.alerttype"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                    全部
                    </a-select-option>
                    <a-select-option value="1">
                    异常告警
                    </a-select-option>
                    <a-select-option value="2">
                    失败率告警
                    </a-select-option>
                    <a-select-option value="3">
                    超时告警
                    </a-select-option>
                </a-select>
          </a-form-item>
          <a-form-item label="屏蔽状态">
                <a-select v-model="searchP.blockstatus"  placeholder="" style="width:100px;">
                    <a-select-option value="">
                    全部
                    </a-select-option>
                    <a-select-option value="屏蔽生效">
                    屏蔽生效
                    </a-select-option>
                    <a-select-option value="屏蔽失效">
                    屏蔽失效 
                    </a-select-option>
                </a-select>
          </a-form-item>
         <a-form-model-item  label="开始日期" prop="starttime">
            <a-date-picker v-model="searchP.starttime" format="YYYY-MM-DD" />
         </a-form-model-item>
         <a-form-model-item  label="结束日期" prop="endtime">
            <a-date-picker  v-model="searchP.endtime"   format="YYYY-MM-DD" />
         </a-form-model-item>
          <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 告警列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
        <span slot="authflag" slot-scope="text">{{flagname[text]}}</span>
    
      <!-- <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
            <a-popconfirm title="确认删除该数据?" @confirm="() => onTaskDelete(record)">
              <a>删除</a>
            </a-popconfirm>
        </div>
      </template>
  -->

    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },{
        title: "系统编码",
        dataIndex: "syscode",
        width:80
    },
    {
        title: "应用编码",
        dataIndex: "appcode",
        width:80
    },
    {
        title: "告警类型",
        dataIndex: "alerttype",
        width:80
    },
    
    {
        title: "屏蔽时间",
        dataIndex: "blocktype",
        width:60
    },
    {
        title: "服务地址",
        dataIndex: "serviceurl", 
        width:180
    },
    {
        title: "屏蔽到期时间",
        dataIndex: "blocktime", 
        width:100
    },
    {
        title: "屏蔽状态",
        dataIndex: "blockstatus", 
        width:80
    },
    {
        title: "屏蔽人",
        dataIndex: "createuser", 
        width:80
    },
    {
        title: "修改人",
        dataIndex: "updateuser",
        width:80
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:100
    },
    {
        title: "修改时间",
        dataIndex: "updatetime",
        width:100
    },

    // {
    //     title: '操作',
    //     dataIndex: 'operation',
    //     align: 'center',
    //     width: 100,
    //     scopedSlots: { customRender: 'operation' },
    // }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        };
    },
    methods: {

        handlePageChange(c_p){
            this.getAlarmList(c_p)
        },
        getAlarmList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.endtime = c_params.endtime ?  this.dateFormat('YYYY-mm-dd',new Date(c_params.endtime)) : '';
            c_params.starttime =c_params.starttime ? this.dateFormat('YYYY-mm-dd',new Date(c_params.starttime)): '';
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/blocklist",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },
        handle_auth_load(ritem){
            window.open(ritem.dashboardurl);
        },

        //删除
        onTaskDelete(key) {
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/deleteblock",
                params:{id:key.id}
            }).then((res) => {
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getAlarmList(1)
                }
            });
        },
        
        handleSearchReset(){
            this.$store.dispatch({
                type: "alarmmanager/getEmptySearch",
                showMsg: true
            })
            this.$refs.shopcodeAs.setInputVal(this.searchP.shopcode);
        },

        handleSubmit(e){
            e.preventDefault();
            this.getAlarmList()
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('alarmmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        this.getAlarmList(1);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
